import UAParser from "ua-parser-js";

export class DeviceOSDetection {
    private os: UAParser.IOS;
    constructor(private parser: UAParser) {
        this.os = this.parser.getOS();
    }

    /**
     * Returns the name of the operating system
     *
     * Possible 'os.name' - data taken from ua-parser-js
     * AIX, AmigaOS, Android, Arch, Bada, BeOS, BlackBerry, CentOS, ChromiumOS, Contiki,
     * Fedora, FirefoxOS, FreeBSD, Debian, DragonFly, Gentoo, GNU, Haiku, Hurd, iOS,
     * Joli, Linpus, Linux, MacOS, Mageia, Mandriva, MeeGo, Minix, Mint, MorphOS, NetBSD,
     * Nintendo, OpenBSD, OpenVMS, OS/2, Palm, PCLinuxOS, Plan9, Playstation, QNX, RedHat,
     * RIM Tablet OS, RISCOS, Sailfish, Series40, Slackware, Solaris, SUSE, Symbian, Tizen,
     * Ubuntu, UNIX, VectorLinux, WebOS, Windows[Phone/Mobile], Zenwalk
     */
    public get name() {
        // ua-parser-js returns human readable names like "Mac OS". I want without spaces to be able to use them as keys in an object
        // example in the external_links_consts.js where macos and safari are used as keys.
        // also, we make it lowercase for comodity
        return this.os.name.replace(/\s/g, "").toLowerCase();
    }

    /**
     * Returns the major version of the operating system
     */
    public get version() {
        return parseInt(this.os.version.split(".")[0]);
    }

    public get isIOS() {
        return this.name === 'ios';
    }

    public get isAndroid() {
        return this.name === 'android';
    }

    public get isPC() {
        return ["centos", "fedora", "debian", "linux", "macos", "pclinuxos", "redhat", "ubuntu", "unix", "vectorlinux", "windows"].indexOf(this.name) && !this.isMobileOS;
    }

    public get isMacOS() {
        return this.name === 'macos';
    }

    public get isMobileOS() {
        return (this.isIOS || this.isAndroid);
    }

}
